//company settings
export const COMP_INFO = {
    NAME: "Supplier Panel",
    TAGLINE: "Come Fly With Us",
    COUNTRY_CODE: "91",
    PHONE1: "9876543210",
    PHONE2: "8976543210",
    HELPLINE1: "1800-234-231",
    HELPLINE2: "1800-322-113",
    EMAIL: "companyemail@gmail.com",
    ADDRESS: "Ruchi Vihar, Vasant Kunj, New Delhi, Delhi 110070"
}


//Backend URL:

//local
//export const BASE_URL = "http://127.0.0.1:8080";


//Stagging
export const BASE_URL = "https://api-supplier.virtualtoactual.cloud";

//Live
//export const BASE_URL = "https://api-supplier-test.v2a.digital";
